import React from 'react'
import BlogBg from '../../../assets/images/blog-bg.png'
import search from '../../../assets/images/search.svg'

export default function BlogBanner({ setKeyword , keyword}) {

  return (
    <section className="section-equal-padding hotel-hero-sec uk-scrollspy-inview"
      style={{ backgroundImage: `url(${BlogBg})`, backgroundRepeat: "no-repeat", backgroundSize: "cover" }}
      uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: false">
      <div className="container">
        <div className="slider-content text-center mx-auto">
          <h1>Our Featured Blogs</h1>
        </div>
        <div className="search-wrapper flight-search-wrpaaer bg-white d-block">
          <div className="flight-booking-form">
            <div className="row">
              <div className="col-md-12">
                <div className="search-item">
                  <div
                    className="search-control-wrapper input-group custom-input d-flex align-items-center gap-2">
                    <img src={search} alt="" />

                    <input
                      className="shadow-none border-0 form-control outline-0 p-0 px-2"
                      placeholder="Search ..."
                      value={keyword}
                      onChange={(e) => setKeyword(e.target.value)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
